































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Icon from './Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class Paginator extends Vue {
  @Prop({ type: Number, default: null }) private previousPage!: number;
  @Prop({ type: Number, default: null }) private currentPage!: number;
  @Prop({ type: Number, default: null }) private nextPage!: number;
  @Prop({ type: Number, default: null }) private lastPage!: number;

  @Emit('set-page')
  setPage(page: number) {
    return page;
  }
}
